import { FC } from 'react';
import { Stack, styled } from '@mui/material';
import { NavigationItem } from './navigation-item';
import { Section } from '../config';

interface NavigationSectionProps {
  section: Section;
}

const SectionHeader = styled('li')(({ theme }) => ({
  color: 'var(--nav-section-title-color)',
  fontSize: 12,
  fontWeight: 700,
  lineHeight: 1.66,
  marginBottom: theme.spacing(1),
  marginLeft: theme.spacing(1),
  textTransform: 'uppercase'
}));

export const NavigationSection: FC<NavigationSectionProps> = ({ section }) => {
  return (
    <Stack
      component="ul"
      spacing={0.5}
      sx={{
        listStyle: 'none',
        m: 0,
        p: 0
      }}
    >
      {section.subheader && <SectionHeader>{section.subheader}</SectionHeader>}
      {section.items.map((item, i) => (
        <NavigationItem
          item={item}
          key={i}
        />
      ))}
    </Stack>
  );
};
